import {T206Timeout, TimeoutReference, TimeoutType} from "./javaTypes";

export function isG301Timeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.G301;
}

export function isT206Timeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.T206;
}

export function isHaltedT206Timeout(timeout: TimeoutReference) {
    return isT206Timeout(timeout) && (timeout as T206Timeout).awaitingScorePost;
}

export function isT206DependencyTimeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.T206_MATCH_DEPENDENCY;
}

export function isLastOnFieldTimeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.LAST_ON_FIELD;
}

export function isScheduledStartTimeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.SCHEDULED_START;
}

export function isAllianceLastTimeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.ALLIANCE_LAST;
}

export function isRunningMatchTimeout(timeout: TimeoutReference) {
    return timeout.type === TimeoutType.RUNNING_MATCH;
}
